import React from 'react'

export const useBreakpointContext = () => React.useContext(BreakpointContext) // Provide the breakpoint as context. The antd implementation adds a new listener

// Provide the breakpoint as context. The antd implementation adds a new listener
// for each use of useBreakpoint which causes render flickering.
export const BreakpointContext = React.createContext<{
  xs: boolean
  sm: boolean
  md: boolean
  lg: boolean
  xl: boolean
  xxl: boolean
}>({
  xs: false,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  xxl: false,
})
